<template>
  <div class="flex flex-wrap gap-4">
    <span
      v-for="(file, index) in modelValue"
      :key="index + '_' + file.name"
      class="relative flex h-20 w-20 cursor-default items-center justify-center rounded border"
    >
      <span class="absolute -right-3 -top-3">
        <div
          class="flex h-6 w-6 cursor-pointer items-center justify-center rounded-full bg-dark-gray"
          @click="onRemoveFile(index)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="11"
            viewBox="0 0 10 11"
            fill="none"
            class="relative z-10"
          >
            <path
              d="M1 9.5L9 1.5"
              stroke="white"
              stroke-width="2"
            />
            <path
              d="M1 1.5L9 9.5"
              stroke="white"
              stroke-width="2"
            />
          </svg>
        </div>
      </span>
      <iframe
        v-if="fileNeedsIframe(file) && (file?.preview || file?.file_url)"
        class="h-20 w-20 cursor-default rounded-md shadow-md"
        :src="
          file?.preview
            ? file.preview + '#toolbar=0&navpanes=0&zoom=0'
            : file?.file_url
              ? file.file_url + '#toolbar=0&navpanes=0&zoom=0'
              : ''
        "
        scrolling="no"
        style="overflow: hidden"
      />
      <img
        v-else-if="file?.preview || file?.file_url"
        class="h-20 w-20 rounded-md shadow-md"
        :src="
          file?.preview ? file.preview : file?.file_url ? file.file_url : ''
        "
        style="overflow: hidden"
      />
      <div
        v-else
        class="flex h-20 w-20 cursor-default flex-col items-center justify-center gap-1 rounded-md px-1 py-3 shadow-md"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="h-8 w-8 flex-shrink-0"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
          />
        </svg>
        <div class="text-center text-3xs leading-none text-body-color">
          {{ file?.name ? file?.name : file?.file_name }}
        </div>
      </div>
      <div
        class="absolute h-20 w-20"
        :class="
          local_uploading_file && index == modelValue?.length - 1
            ? 'bg-light-gray bg-opacity-20'
            : 'bg-transparent'
        "
      >
        <div
          v-if="local_uploading_file && index == modelValue?.length - 1"
          class="absolute flex h-20 w-20 items-center justify-center"
        >
          <svg
            class="loading h-8 w-8 text-placeholder-gray"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M28 16C28 18.3734 27.2962 20.6935 25.9776 22.6668C24.6591 24.6402 22.7849 26.1783 20.5922 27.0866C18.3995 27.9948 15.9867 28.2324 13.6589 27.7694C11.3311 27.3064 9.19295 26.1635 7.51472 24.4853C5.83649 22.8071 4.6936 20.6689 4.23058 18.3411C3.76755 16.0133 4.00519 13.6005 4.91345 11.4078C5.8217 9.21509 7.35977 7.34094 9.33316 6.02236C11.3065 4.70379 13.6266 4 16 4"
              stroke="currentColor"
              stroke-width="3"
            />
            <path
              d="M16 1V7L20 4L16 1Z"
              fill="currentColor"
            />
            <path
              d="M22.4895 7.161C24.4444 8.50678 25.9564 10.402 26.8342 12.6071"
              stroke="currentColor"
              stroke-width="3"
            />
          </svg>
        </div>
        <div>
          <info-tooltip
            color-scheme="dark"
            content="'1'"
            class="relative"
            style="top: 1.5px"
            :hide-icon="true"
            placement="bottom"
            :quick="true"
          >
            <div>
              <p class="text-xxs">
                {{ file?.name ? file?.name : file?.file_name }}
              </p>
            </div>
          </info-tooltip>
        </div>
      </div>
    </span>
    <span
      v-if="
        question?.is_type == 'file_multiple' ||
        (modelValue.length < 1 && question?.is_type == 'file')
      "
      class="relative z-10 flex h-20 w-20 cursor-pointer items-center justify-center rounded-lg border-2 border-dashed border-yellow-300"
      @click="onClickSelect"
      @drop.prevent="dropFile"
      @dragover.prevent
      @dragenter.prevent="fileOverDropArea = true"
      @dragleave.prevent="fileOverDropArea = false"
    >
      <div
        class="absolute bottom-0 left-0 right-0 top-0 z-0 rounded-lg bg-yellow-500 opacity-10"
      />
      <!-- <img class="relative z-10" src="@/assets/plus-yellow-icon.svg"/> -->
      <svg
        class="relative z-10"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.0007 11L5.93555 11L5.93555 13L11.0007 13L11.0007 18.0645L13.0007 18.0645L13.0007 13L18.0651 13V11H13.0007L13.0007 5.93489H11.0007L11.0007 11Z"
          fill="#F8C617"
        />
      </svg>

      <!-- <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m3.75 9v6m3-3H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
      </svg> -->
    </span>
    <!-- <span 
      class="px-4 py-2 pl-2.5 relative flex flex-col gap-0 items-center justify-center border-placeholder-gray hover:border-yellow-500 border-dashed border-2 rounded-lg z-10 cursor-pointer group bg-off-white hover:bg-transparent text-body-color group-hover:text-yellow-500" 
      @click="onClickSelect"
      @drop.prevent="dropFile"
      @dragover.prevent
      @dragenter.prevent="fileOverDropArea = true"
      @dragleave.prevent="fileOverDropArea = false"
    >
      <div class="top-0 bottom-0 left-0 right-0 absolute bg-transparent group-hover:bg-yellow-500 opacity-5 z-0 rounded-lg group-hover:opacity-10"></div>
      <div class="w-full flex gap-1.5">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-8 h-8 relative z-10 text-gray-over-dark group-hover:text-yellow-600">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 16.5V9.75m0 0l3 3m-3-3l-3 3M6.75 19.5a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z" />
        </svg>
        <div class="text-xs relative z-10 flex flex-col items-center justify-center text-gray-over-dark group-hover:text-yellow-600">
          <span class="font-medium">Upload PDF</span>
          <span class="text-2xs leading-tight">or drag & drop</span>
        </div>
      </div>
    </span> -->
    <input
      :ref="`file-input-question-${question_id}`"
      type="file"
      :accept="accept"
      :multiple="multiple"
      :disabled="disabled"
      @change="onFileSelect"
    />
  </div>
</template>

<script>
// import { objectToFormData } from '@/common/json';
import { mapState } from 'vuex';
import { toastResponse } from '@/common/handleServerResponse';
import InfoTooltip from '@/components/InfoTooltip.vue';

export default {
  name: 'FileSelectorGridQuestions',
  components: { InfoTooltip },
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
    accept: String,
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: Boolean,
    question: Object,
    question_id: Number,
    subject: String,
    setOnboardingPacket: Function,
    toggleRequired: Function,
    required: Boolean,
    conditional_children: Array,
  },
  emits: ['run-comparison', 'update:modelValue'],
  data() {
    return {
      answer: [],
      fileUploads: [],
      answerId: null,
      loading: false,
      local_uploading_file: false,
    };
  },
  computed: {
    most_recent_previous_answer() {
      return this.question?.most_recent_previous_answer;
    },
    current_answer() {
      return this.question?.current_answer;
    },
    ...mapState({
      onboardingPacketId: (state) => state.onboardingPacket.id || null,
      uploadingFile: (state) => state.questions?.uploading_file || false,
    }),
  },
  watch: {
    // most_recent_previous_answer: {
    //   handler: function (newVal, oldVal) {
    //     console.log('watch most_recent_previous_answer running...');
    //     var self = this;
    //     if (newVal?.file_uploads?.length > 0 && newVal?.onboarding_packet_id == self.onboardingPacketId) {
    //       self.answerId = newVal?.id;
    //     } else if (!newVal?.file_uploads || newVal?.file_uploads?.length == 0) {
    //       self.answerId = null;
    //     }
    //     if (self.answer?.length > 0) {
    //       if (newVal?.file_uploads?.length > 0 && newVal?.file_uploads !== oldVal?.file_uploads) {
    //         self.fileUploads = [];
    //         newVal.file_uploads.forEach(function(file) {
    //           self.fileUploads.push({
    //             id: file?.id,
    //             name: file?.name ? file?.name : file?.file_name,
    //           });
    //         });
    //       } else if (!newVal?.file_uploads || newVal?.file_uploads?.length == 0) {
    //         self.fileUploads = [];
    //       }
    //     } else {
    //       self.fileUploads = [];
    //     }
    //   },
    //   deep: true
    // }
  },
  mounted() {
    var self = this;
    if (this.question?.most_recent_previous_answer?.file_uploads?.length > 0) {
      self.fileUploads = [];
      this.question.most_recent_previous_answer.file_uploads.forEach(
        function (file) {
          self.fileUploads.push({
            id: file?.id,
            name: file?.name ? file?.name : file?.file_name,
          });
        }
      );
      const recentFiles = [
        ...(this.question?.most_recent_previous_answer?.file_uploads ?? []),
      ];
      this.$emit('update:modelValue', [...recentFiles]);
    } else if (this.question?.current_answer?.file_uploads?.length > 0) {
      self.fileUploads = [];
      this.question.current_answer.file_uploads.forEach(function (file) {
        self.fileUploads.push({
          id: file?.id,
          name: file?.name ? file?.name : file?.file_name,
        });
      });
      const currentFiles = [
        ...(this.question?.current_answer?.file_uploads ?? []),
      ];
      this.$emit('update:modelValue', [...currentFiles]);
    }
  },
  methods: {
    async handleInput(targetFiles) {
      this.answer = [...this.modelValue];
      console.log('THIS.ANSWER');
      console.dir(this.answer);
      // console.log('e.target.files');
      // console.dir(e.target.files);
      // console.dir([ ...e.target.files ]);
      let fileUpload = new FormData();
      fileUpload.append(
        'onboarding_packet[answers_attributes][0][company_question_id]',
        this.question_id
      );
      if (this.answerId !== null) {
        fileUpload.append(
          'onboarding_packet[answers_attributes][0][id]',
          this.answerId
        );
      }
      if (this.multiple == false) {
        fileUpload.append(
          'onboarding_packet[answers_attributes][0][string_value]',
          targetFiles[0]?.name
        );
        fileUpload.append(
          'onboarding_packet[answers_attributes][0][file_uploads_attributes][0][file_name]',
          targetFiles[0]?.name
        );
        fileUpload.append(
          'onboarding_packet[answers_attributes][0][file_uploads_attributes][0][company_question_id]',
          this.question_id
        );
        fileUpload.append(
          'onboarding_packet[answers_attributes][0][file_uploads_attributes][0][onboarding_packet_id]',
          this.onboardingPacketId
        );
        fileUpload.append(
          'onboarding_packet[answers_attributes][0][file_uploads_attributes][0][document]',
          targetFiles[0]
        );
      } else {
        let self = this;
        let fileNames = [];
        this.answer.forEach(function (file, index) {
          console.log('index', index);
          console.log('file', file);
          fileNames.push(file?.name);
          let previouslyUploaded = self.fileUploads.find(function (f) {
            return f.name == file?.name;
          });
          if (previouslyUploaded) {
            fileUpload.append(
              'onboarding_packet[answers_attributes][0][file_uploads_attributes][' +
                index +
                '][id]',
              previouslyUploaded?.id
            );
          }
          fileUpload.append(
            'onboarding_packet[answers_attributes][0][file_uploads_attributes][' +
              index +
              '][file_name]',
            file?.name
          );
          fileUpload.append(
            'onboarding_packet[answers_attributes][0][file_uploads_attributes][' +
              index +
              '][company_question_id]',
            self.question_id
          );
          fileUpload.append(
            'onboarding_packet[answers_attributes][0][file_uploads_attributes][' +
              index +
              '][onboarding_packet_id]',
            self.onboardingPacketId
          );
          fileUpload.append(
            'onboarding_packet[answers_attributes][0][file_uploads_attributes][' +
              index +
              '][document]',
            self.answer?.[index]
          );
        });
        fileUpload.append(
          'onboarding_packet[answers_attributes][0][string_value]',
          fileNames.join(', ')
        );
      }
      this.$store.commit(
        'addFormDebugMessage',
        'AUTO PACKET UPDATE | Questions > FileSelectorGridQuestions: (handleInput) carrier file_upload data sent to server'
      );
      this.local_uploading_file = true;
      let res = await this.$store.dispatch(
        'onboardingPacket/updatePacketForFileUpload',
        fileUpload
      );
      if ([200, 201].includes(res?.status)) {
        this.local_uploading_file = false;
        if (this.answer?.length > 1) {
          toastResponse(this, res, 'Files uploaded');
        } else {
          toastResponse(this, res, 'File uploaded');
        }
        if (this.required) {
          this.answer?.length > 0
            ? this.toggleRequired(this.question_id, true)
            : this.toggleRequired(this.question_id, false);
        }

        var self = this;
        this.question.current_answer.file_uploads.forEach(function (file) {
          if (!self.fileUploads.find((el) => el.id === file?.id)) {
            self.fileUploads.push({
              id: file?.id,
              name: file?.name ? file?.name : file?.file_name,
            });
          }
        });
        this.$emit('update:modelValue', this.answer);
        this.$emit('run-comparison', this.answer?.length > 0);
      } else if (res?.status === 403) {
        this.local_uploading_file = false;
        this.$toast.open({
          message:
            'Error uploading file. Please ensure the PDF is formatted correctly and try again.',
          type: 'error',
          position: 'top-right',
          duration: 5000,
        });
        this.autoRemoveFile();
      } else if (res?.status === 422) {
        this.local_uploading_file = false;
        toastResponse(this, res, null);
        this.autoRemoveFile();
      }
    },
    fileNeedsIframe: function (file) {
      const iframeTypes = ['application/pdf'];
      if (file?.type) {
        return iframeTypes.includes(file.type);
      } else if (file?.file_name) {
        return file.file_name.includes('.pdf');
      }
    },
    autoRemoveFile: async function () {
      const newFiles = [...this.modelValue];
      const index = newFiles?.length - 1;
      URL.revokeObjectURL(newFiles[index].preview);
      newFiles.splice(index, 1);
      this.fileUploads.splice(index, 1);
      this.$emit('update:modelValue', [...newFiles]);

      if (this.required) {
        newFiles?.length > 0
          ? this.toggleRequired(this.question_id, true)
          : this.toggleRequired(this.question_id, false);
      }

      this.$emit('run-comparison', newFiles?.length > 0);
    },
    onRemoveFile: async function (index, hideToast = false) {
      const newFiles = [...this.modelValue];
      URL.revokeObjectURL(newFiles[index].preview);
      newFiles.splice(index, 1);
      let res = await this.$store.dispatch(
        'questions/deleteFileUpload',
        this.fileUploads?.[index]?.id
      );
      if (res && hideToast == true) {
        toastResponse(this, res, 'File removed');
      }
      if (res?.status === 204) {
        this.fileUploads.splice(index, 1);
      }

      // console.log('removeFiles');
      // console.dir(newFiles);
      // console.dir([ ...newFiles]);
      // console.dir(this.modelValue);

      // console.dir(this.modelValue);
      console.log('mv3');
      this.$emit('update:modelValue', [...newFiles]);

      // let el = this.$refs[`file-input-question-${this.question_id}`];
      // el.dispatchEvent(new Event('change'));

      if ([200, 201, 204].includes(res?.status) && this.required) {
        newFiles?.length > 0
          ? this.toggleRequired(this.question_id, true)
          : this.toggleRequired(this.question_id, false);
      }

      this.$emit('run-comparison', newFiles?.length > 0);
    },
    onClickSelect: function () {
      // this.$refs.fileInput.click();
      this.$refs[`file-input-question-${this.question_id}`].click();
    },
    dropFile: async function (event) {
      const files = event.dataTransfer.files;
      if (!files) {
        return;
      }
      await this.refreshFiles(files);
      this.handleInput(event.dataTransfer.files);
    },
    refreshFiles: function (files) {
      for (const file of files) {
        file.preview = URL.createObjectURL(file);
      }
      console.log(files);
      console.log('mv4');
      this.$emit('update:modelValue', [...files]);
    },
    onFileSelect: async function (event) {
      let files = [...this.modelValue];
      let newFiles = [...event.target.files];
      files.forEach(function (file) {
        if (file?.name == newFiles[0]?.name) {
          newFiles = [];
        }
      });
      newFiles.forEach(function (f) {
        files.push(f);
      });

      console.log('files');
      console.dir(files);
      if (!files || files?.length === 0) {
        return;
      }
      await this.refreshFiles(files);
      this.handleInput(event.target.files);
    },
  },
};
</script>

<style>
input[type='file'] {
  display: none;
}

iframe {
  overflow: hidden;
}
</style>
